/**
 * Saves `url` to disk via a detached, programmatically-clicked `<a
 * download>` — the anchor is briefly attached to the DOM (some browsers
 * ignore `download` on a detached element) then removed once the click has
 * been dispatched.
 *
 * This is a browser download hint, not a fetch: for a plain remote
 * cross-origin URL the browser is free to ignore `download` and navigate
 * there instead unless the response itself sets `Content-Disposition:
 * attachment`. Callers downloading third-party content should fetch it into
 * a `blob:` URL first (or route through a same-origin proxy that sets that
 * header) — `download` is honoured reliably for `blob:`/`data:` URLs and
 * same-origin URLs regardless of response headers. See
 * `CallRecordingDownloadButton` for an example.
 */
export function triggerDownload(url: string, filename: string): void {
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  link.rel = 'noopener noreferrer'
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
